// antd theme tokens, kept in step with the Tailwind theme in tailwind.config.js.
// Most of this app is antd Tables/Modals/Inputs, so these tokens are what carry
// the palette across the data pages -- update both files together.

const gold = {
  50: '#FBFAF6',
  100: '#F4F1E6',
  200: '#E8E2CC',
  500: '#A69961',
  600: '#8A7E4E',
  800: '#4E472A',
};

export const fontFamily =
  "'Montserrat', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif";

const antdTheme = {
  token: {
    colorPrimary: gold[600],
    colorInfo: '#0F766E',
    colorLink: '#0F766E',
    colorLinkHover: '#115E59',
    colorSuccess: '#15803D',
    colorWarning: '#B45309',
    colorError: '#B91C1C',

    colorText: '#1C1917',
    colorTextSecondary: '#57534E',
    colorTextTertiary: '#78716C',
    colorTextQuaternary: '#A8A29E',

    colorBorder: '#E7E5E4',
    colorBorderSecondary: '#F0EEEC',
    colorBgLayout: '#FAF9F7',

    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,

    fontFamily,
    fontSize: 14,

    controlHeight: 36,
    controlHeightSM: 30,

    boxShadow:
      '0 1px 2px 0 rgb(28 25 23 / 0.04), 0 1px 3px 0 rgb(28 25 23 / 0.06)',
    boxShadowSecondary:
      '0 4px 6px -1px rgb(28 25 23 / 0.07), 0 10px 20px -6px rgb(28 25 23 / 0.12)',
  },
  components: {
    Table: {
      headerBg: gold[100],
      headerColor: gold[800],
      headerSplitColor: gold[200],
      headerBorderRadius: 12,
      rowHoverBg: gold[50],
      borderColor: '#EDEBE9',
      cellFontSizeSM: 13,
      footerBg: '#FAF9F7',
    },
    Button: {
      fontWeight: 600,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Modal: {
      titleFontSize: 18,
      headerBg: '#FFFFFF',
      contentBg: '#FFFFFF',
    },
    Input: {
      activeShadow: '0 0 0 3px rgb(166 153 97 / 0.15)',
      hoverBorderColor: gold[500],
      activeBorderColor: gold[600],
    },
    Select: {
      optionSelectedBg: gold[100],
      optionSelectedColor: gold[800],
      optionActiveBg: gold[50],
    },
    Tag: {
      defaultBg: gold[50],
      defaultColor: gold[800],
    },
    Switch: {
      handleShadow: '0 2px 4px 0 rgb(28 25 23 / 0.2)',
    },
    Tooltip: {
      colorBgSpotlight: '#1C1917',
    },
    Popover: {
      titleMinWidth: 160,
    },
    DatePicker: {
      activeShadow: '0 0 0 3px rgb(166 153 97 / 0.15)',
      hoverBorderColor: gold[500],
      activeBorderColor: gold[600],
    },
  },
};

export default antdTheme;
